import React from 'react';
import { Button, FormHelperText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ImageInputProps from 'types/components/ImageInputProps';
import 'styles/components/ImageInput.scss';

export default ({
  label,
  name,
  value,
  setFieldValue,
  isSubmitting,
  idealSize,
  touched,
  errors,
  preview,
  className,
  previewDimensions,
  uploadButtonDimensions,
}: ImageInputProps): JSX.Element => {
  const [thumb, setThumb] = React.useState<any>(null);
  const [loading, setLoading] = React.useState<boolean>(true);
  const { t } = useTranslation();

  React.useEffect(() => {
    const reader = new FileReader();
    if (value) {
      reader.onloadend = () => {
        setLoading(false);
        setThumb(reader.result);
      };
      reader.readAsDataURL(value);
    } else if (preview) {
      setLoading(false);
      setThumb(preview);
    }
    return () => {
      reader.abort();
    };
  }, [value, preview]);

  const Thumb = (): JSX.Element | null => {
    if (loading) {
      return <p>{t('image-input-loading')}</p>;
    }
    return (
      <img
        src={thumb}
        height={previewDimensions ? previewDimensions.height : 200}
        width={previewDimensions ? previewDimensions.width : 200}
      />
    );
  };

  return (
    <div className={uploadButtonDimensions ? 'container' : ''}>
      {thumb && (
        <div className={`thumb-container ${className}`}>
          <Thumb />
        </div>
      )}
      <Button
        variant="contained"
        color="secondary"
        component="label"
        disabled={isSubmitting}
        className={className ? className : ''}
        style={
          uploadButtonDimensions
            ? {
                width: uploadButtonDimensions.width,
                height: uploadButtonDimensions.height,
              }
            : undefined
        }
      >
        {label}
        <input
          id={name}
          name={name}
          type="file"
          hidden
          onChange={(event) => {
            const files = event?.currentTarget?.files;
            if (files && files[0]) setFieldValue(name, files[0]);
          }}
        />
      </Button>
      {thumb && (
        <div className="delete-thumb-image-btn-container">
          <Button
            className={className}
            variant="contained"
            onClick={async () => {
              await setFieldValue(name, null);
              await setThumb(null);
            }}
            style={
              uploadButtonDimensions
                ? {
                    width: uploadButtonDimensions.width,
                    height: uploadButtonDimensions.height,
                  }
                : undefined
            }
          >
            {t('remove-image')}
          </Button>
        </div>
      )}

      <FormHelperText variant="outlined" error={true}>
        {touched ? errors : ''}
      </FormHelperText>
      {idealSize && (
        <div className="ideal-size-message">
          {`${t('image-input-image-size')} ${idealSize.width.toFixed(0)} x ${idealSize.height.toFixed(0)}`}
        </div>
      )}
    </div>
  );
};
